const MicIcon = ({ hotMode = false }: { hotMode?: boolean }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
      <g clipPath="url(#clip0_56_893)">
        <path
          d="M11.8333 4.79653V7.4632C11.8333 9.30414 10.3409 10.7965 8.49996 10.7965C6.65901 10.7965 5.16663 9.30414 5.16663 7.4632V4.79653C5.16663 2.95558 6.65901 1.4632 8.49996 1.4632C10.3409 1.4632 11.8333 2.95558 11.8333 4.79653Z"
          stroke={hotMode ? '#cc3b33' : 'currentColor'}
        />
        <path
          d="M11.8333 4.79657H9.83331M11.8333 7.46324H9.83331"
          stroke={hotMode ? '#cc3b33' : 'currentColor'}
          strokeLinecap="round"
        />
        <path
          d="M13.8333 7.4632C13.8333 10.4087 11.4455 12.7965 8.49996 12.7965M8.49996 12.7965C5.55444 12.7965 3.16663 10.4087 3.16663 7.4632M8.49996 12.7965V14.7965M8.49996 14.7965H10.5M8.49996 14.7965H6.49996"
          stroke={hotMode ? '#cc3b33' : 'currentColor'}
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_56_893">
          <rect width="16" height="16" fill="white" transform="translate(0.5 0.129883)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MicIcon;
